import { createSlice } from "@reduxjs/toolkit";
import { initialData } from "./services/initialDataService";

const initialState: initialData = {
    home: {
        topBanner: {
            imageUrl: "",
            textOverlay: {
                title: "",
                description: "",
            },
        },
        sliderProducts: [],
        signatureDishes: [],
        userReviews: [],
        newArrivals: []
    },
    promise: {
        topBanner: {
            imageUrl: "",
            textOverlay: {
                title: "",
                description: "",
            },
        },
        introVideo: "",
    },
    contactInfo: {
        email: "",
        phoneNumber: "",
    },
    menu: {
        specialdishes: [
            {
                displayName: "",
                description: "",
                imageUrl: "",
                id: "",
            }
        ],
        introVideo: "",
        quickOrder: {
            displayName: "",
            description: "",
            imageUrl: "",
            id: "",
            nutrients: {
                calories: 0,
                protein: 0,
                carbs: 0,
                fat: 0,
            },
        },
    }
};
const initialDataSlice = createSlice({
    name: 'initialData',
    initialState,
    reducers: {
        setInitialData: (state, action) => {
            return { ...state, ...action.payload };
        },
        clearInitialData: (state) => {
            return initialState;
        },
    },
});
export const { setInitialData, clearInitialData } = initialDataSlice.actions;
export default initialDataSlice.reducer;